module.exports = __webpack_public_path__ + "static/media/gibraltar.b614c081.png";